/* Custom Product Grid — cart-mode ATC interceptor.
   Funnels Add to Cart through /cart/add.js so Rebuy SmartCart auto-opens
   instead of the native form POST 302-redirecting to /cart.

   Click-delegated on the button (not the form) so preventDefault on click
   cancels the default action (form submit) before any theme/app submit
   handler can fire. Strictly scoped to <button class="block-atc-btn">
   inside .custom-product-grid-section — no other ATC surface is touched.
   Link-mode tiles (<a class="block-atc-btn block-atc-btn--link">) are
   filtered out by the button tag selector and keep navigating normally.

   Loaded globally from layout/theme.liquid so a Shopify-side section
   revert can't drop the interceptor again (as happened with a3f677e
   rolling back the previous inline-script fix on 2026-06-16). */
(function () {
  if (window.__wrCpgAtcInit) return;
  window.__wrCpgAtcInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button.block-atc-btn');
    if (!btn) return;
    if (!btn.closest('.custom-product-grid-section')) return;

    var form = btn.closest('form');
    if (!form) return;

    e.preventDefault();

    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        console.error('CPG ATC error:', err);
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  });
})();
